var map = {
	"./404.svg": "oUrx",
	"./bug.svg": "F3lI",
	"./chart.svg": "yCkv",
	"./clipboard.svg": "vDVG",
	"./component.svg": "VtY+",
	"./dashboard.svg": "94Jb",
	"./documentation.svg": "kPu2",
	"./drag.svg": "m7++",
	"./edit.svg": "qkZ8",
	"./email.svg": "y7eQ",
	"./example.svg": "MMMJ",
	"./excel.svg": "ZZmv",
	"./eye.svg": "TfVu",
	"./form.svg": "6xvN",
	"./guide 2.svg": "ICep",
	"./guide.svg": "ZoO1",
	"./icon.svg": "nZHn",
	"./international.svg": "F9+T",
	"./language.svg": "JYDz",
	"./link.svg": "GPBF",
	"./list.svg": "MokB",
	"./lock.svg": "qwAt",
	"./message.svg": "R/8a",
	"./money.svg": "MEYL",
	"./nested.svg": "3PhE",
	"./password.svg": "Kj24",
	"./people.svg": "0Fbn",
	"./peoples.svg": "LxGF",
	"./qq.svg": "FDDl",
	"./shopping.svg": "EqXK",
	"./size.svg": "hkRB",
	"./star.svg": "cIpu",
	"./tab.svg": "j7e1",
	"./table.svg": "R/Hx",
	"./theme.svg": "5TQQ",
	"./tree.svg": "k80C",
	"./user.svg": "s7Vf",
	"./wechat.svg": "gNoN",
	"./zip.svg": "iqZD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";